import LandingPageComponent from "./components/LandingPageComponent";
const pageTitle = "Beyond Ulta Beauty Rewards";
const routes = [{
        path: '/',
        // component: () =>  import('./components/LandingPageComponent.vue'),
        component: LandingPageComponent,
        name: 'landing',
        meta: {
            title: pageTitle
        }
    },
    {
        path: '/sign_in',
        component: () => import( /* webpackChunkName: "sign_in", webpackPrefetch: 0 */ './components/SignInComponent.vue'),
        name: 'sign_in',
        meta: {
            title: 'Sign In | ' + pageTitle
        }
    },
    {
        path: '/register',
        component: () => import('./components/RegisterComponent.vue'),
        name: 'register',
        meta: {
            title: 'Register | ' + pageTitle
        }
    },
    {
        path: '/forgot_password',
        component: () => import('./components/ForgotPasswordComponent.vue'),
        name: 'forgot_password',
        meta: {
            title: 'Forgot Password | ' + pageTitle
        }
    },
    {
        path: '/email-activation',
        component: () => import('./components/email_activation/EmailOfferLandingComponent.vue'),
        name: 'email-activation',
        meta: {
            title: 'Email Activation | ' + pageTitle
        }
    },
    {
        path: '/reset-password/:token',
        component: () => import('./components/ResetPasswordComponent.vue'),
        name: 'reset-password',
        meta: {
            title: 'Reset Password | ' + pageTitle
        }
    },
    {
        path: '/dashboard',
        component: () => import('./components/DashboardComponent.vue'),
        name: 'dashboard',
        meta: {
            requiresAuth: true,
            title: 'Dashboard | ' + pageTitle
        }
    },
    {
        path: '/offers',
        component: () => import('./components/OffersComponent.vue'),
        name: 'offers',
        meta: {
            requiresAuth: true,
            title: 'Offers | ' + pageTitle
        }
    },
    {
        path: '/my_account',
        component: () => import('./components/MyAccountComponent.vue'),
        name: 'my_account',
        meta: {
            requiresAuth: true,
            title: 'My Account | ' + pageTitle
        }
    },
    {
        path: '/search_result',
        component: () => import('./components/search/SearchResultsComponent.vue'),
        name: 'search-results',
        meta: {
            requiresAuth: true,
            title: 'Offers Search Results | ' + pageTitle
        }
    },
    {
        path: '/transaction_details',
        component: () => import('./components/TransactionDetailsComponent.vue'),
        name: 'transaction-details',
        meta: {
            requiresAuth: true,
            title: 'Transaction Details | ' + pageTitle
        }
    },
    {
        path: '/all_categories',
        component: () => import('./components/AllCategoriesComponent.vue'),
        name: 'all-categories',
        meta: {
            requiresAuth: true,
            title: 'All Offer Categories | ' + pageTitle
        }
    },
    {
        path: '/faqs',
        component: () => import('./components/static/FaqsComponent.vue'),
        name: 'faqs',
        meta: {
            requiresAuth: false,
            title: 'FAQs | ' + pageTitle
        }
    },
    {
        path: '/tnc',
        component: () => import('./components/static/tncComponent.vue'),
        name: 'tnc',
        meta: {
            requiresAuth: false,
            title: 'TNC | ' + pageTitle
        }
    },
    {
        // Backend-driven campaign landing pages (e.g. /valvoline). The slug -> offer
        // mapping lives in config/campaigns.php and the enabled slugs are exposed via
        // window.appGlobalData.campaignSlugs, so adding a campaign needs no route change.
        path: '/:slug',
        component: () => import('./components/campaign/CampaignLandingComponent.vue'),
        name: 'campaign',
        meta: {
            title: 'Offer | ' + pageTitle
        },
        beforeEnter: (to, from, next) => {
            let slugs = (window.appGlobalData && window.appGlobalData.campaignSlugs) || [];
            if (slugs.indexOf(to.params.slug) !== -1) {
                next();
            } else {
                next({ path: '/' });
            }
        }
    },
    {
        path: '*',
        redirect: '/'
    }
];


export default routes;
